import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { formatPrice } from "@/lib/store";
import { WhatsAppIcon } from "../WhatsAppIcon";

// Barra fixa no celular/tablet: resumo da avaliação e o botão do WhatsApp sempre à mão.
// Some quando o botão principal (no fim do formulário) já está na tela.
export const TradeStickyBar = ({ target, est, diff, busy, error }) => {
  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    const el = target.current;
    if (!el) return undefined;
    const io = new IntersectionObserver(([e]) => setHidden(e.isIntersecting || e.boundingClientRect.top < 0), { threshold: 0.1 });
    io.observe(el);
    return () => io.disconnect();
  }, [target]);
  if (hidden) return null;
  const money = (v) => (Number(v) > 0 ? formatPrice(v) : "R$ 0,00");
  const [label, value] = diff < 0 ? ["Você recebe de volta", money(-diff)] : diff != null ? ["Diferença estimada", money(diff)] : est ? ["Avaliação estimada", money(est.value)] : ["Avaliação", "pela loja"];
  return (
    <div data-testid="trade-sticky-bar" className="fixed-bottom-extend fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-[#0d0d0f]/90 px-4 pb-[calc(env(safe-area-inset-bottom)+12px)] pt-3 backdrop-blur-xl lg:hidden">
      {error && <p data-testid="trade-sticky-error" className="mb-2 text-xs text-amber-300">{error}</p>}
      <div className="mx-auto flex max-w-2xl items-center gap-3">
        <div className="min-w-0 flex-1">
          <p className="text-[11px] uppercase tracking-[0.16em] text-zinc-400">{label}</p>
          <p data-testid="trade-sticky-value" className="font-display truncate text-lg font-bold text-white">{value}</p>
        </div>
        <button type="submit" data-testid="trade-sticky-submit" disabled={busy}
          className="flex shrink-0 items-center gap-2 rounded-full bg-[#25D366] px-5 py-3 text-sm font-bold text-black transition-transform active:scale-95 disabled:opacity-70">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <WhatsAppIcon className="h-4 w-4" />} Enviar no WhatsApp
        </button>
      </div>
    </div>
  );
};
